import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {AlertController} from '@ionic/angular';

@Component({
    selector: 'select-document-type',
    templateUrl: './select-document-type.component.html',
    styleUrls: ['./select-document-type.component.scss'],
})
export class SelectDocumentTypeComponent implements OnInit {

    @Input() docTypes: any[];
    @Input() document: DocumentModel;
    @Output() docTypeChanged: EventEmitter<number> = new EventEmitter<number>();
    type: any;
    previousType: any;

    constructor(private alertController: AlertController) {
    }

    ngOnInit() {
        for (const type of this.docTypes) {
            if (type.id === this.document.documentType) {
                this.type = type;
                break;
            }
        }
        console.log(this.type);
        // this.setDocType(this.type);
    }

    setDocType(event) {
        for (const t of this.docTypes) {
            if (t.description === event.detail.value) {
                console.log(event.detail.value, t.id);
                // this.document.documentType = t.id;
                this.docTypeChanged.emit(t.id);
            }
        }
    }

    async confirmChange(event) {
        this.previousType = this.document.documentType;
        if (this.document.documentType === 0 || this.document.detailLines.length === 0) {
            this.setDocType(event);
        } else {
            const alert = await this.alertController.create({
                message: 'Do you want to change the Document Type? (Changing this will reset the detaillines)',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            event.detail.value = this.type;
                            this.type = event.detail.value;
                            this.setDocType(event);
                        }
                    }, {
                        text: 'Yes',
                        handler: () => {
                            this.setDocType(event);
                        }
                    }
                ]
            });
            await alert.present();
        }

    }
}
